import * as React from 'react';
export function useFocusOptionController(_ref) {
  let {
    length,
    minIndex = 0
  } = _ref;
  const [focusedIndex, setFocusedIndex] = React.useState(-1);
  const moveFocus = delta => {
    const nextIndex = focusedIndex + delta;
    if (nextIndex < minIndex || nextIndex >= length) {
      return;
    }
    setFocusedIndex(nextIndex);
  };
  return {
    focusedIndex,
    actions: {
      moveFocus,
      setFocusedIndex
    }
  };
}